import React, { useMemo, useState } from "react"
import { useSelector } from "react-redux"
import { jwtDecode } from "jwt-decode"
import DashboardTab from "../components/Referrals/DashboardTab"
import ConfigurationTab from "../components/Referrals/ConfigurationTab"
import RewardsTab from "../components/Referrals/RewardsTab"
import UsersTab from "../components/Referrals/UsersTab"
import ActivityLogsTab from "../components/Referrals/ActivityLogsTab"
import { translations } from "../utils/Translation/staticTranslation"
import "../styles/Pages/referrals.css"
import {
  isProfileModuleDeleteBlocked,
  isProfileModuleReadOnly,
} from "../utils/modulePermissionSidebar"
import { getUserCookies } from "../utils/Cookies"

/** Inline paths from public/referrals/menu-square-admin.svg — currentColor matches tab active/inactive text */
const ReferralsDashboardTabIcon = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    className="ref-tab-dashboard-svg"
  >
    <g clipPath="url(#referrals_dashboard_tab_clip)">
      <path
        d="M1.33331 12.0007C1.33331 10.9737 1.33331 10.4602 1.56447 10.083C1.69381 9.87194 1.87127 9.69448 2.08233 9.56514C2.45954 9.33398 2.97302 9.33398 3.99998 9.33398C5.02694 9.33398 5.54042 9.33398 5.91762 9.56514C6.12869 9.69448 6.30615 9.87194 6.43549 10.083C6.66665 10.4602 6.66665 10.9737 6.66665 12.0007C6.66665 13.0276 6.66665 13.5411 6.43549 13.9183C6.30615 14.1294 6.12869 14.3068 5.91762 14.4362C5.54042 14.6673 5.02694 14.6673 3.99998 14.6673C2.97302 14.6673 2.45954 14.6673 2.08233 14.4362C1.87127 14.3068 1.69381 14.1294 1.56447 13.9183C1.33331 13.5411 1.33331 13.0276 1.33331 12.0007Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M9.33331 12.0007C9.33331 10.9737 9.33331 10.4602 9.56447 10.083C9.69381 9.87194 9.87127 9.69448 10.0823 9.56514C10.4595 9.33398 10.973 9.33398 12 9.33398C13.0269 9.33398 13.5404 9.33398 13.9176 9.56514C14.1287 9.69448 14.3062 9.87194 14.4355 10.083C14.6666 10.4602 14.6666 10.9737 14.6666 12.0007C14.6666 13.0276 14.6666 13.5411 14.4355 13.9183C14.3062 14.1294 14.1287 14.3068 13.9176 14.4362C13.5404 14.6673 13.0269 14.6673 12 14.6673C10.973 14.6673 10.4595 14.6673 10.0823 14.4362C9.87127 14.3068 9.69381 14.1294 9.56447 13.9183C9.33331 13.5411 9.33331 13.0276 9.33331 12.0007Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M1.33331 4.00065C1.33331 2.97369 1.33331 2.46021 1.56447 2.08301C1.69381 1.87194 1.87127 1.69448 2.08233 1.56514C2.45954 1.33398 2.97302 1.33398 3.99998 1.33398C5.02694 1.33398 5.54042 1.33398 5.91762 1.56514C6.12869 1.69448 6.30615 1.87194 6.43549 2.08301C6.66665 2.46021 6.66665 2.97369 6.66665 4.00065C6.66665 5.02761 6.66665 5.54109 6.43549 5.9183C6.30615 6.12936 6.12869 6.30682 5.91762 6.43617C5.54042 6.66732 5.02694 6.66732 3.99998 6.66732C2.97302 6.66732 2.45954 6.66732 2.08233 6.43617C1.87127 6.30682 1.69381 6.12936 1.56447 5.9183C1.33331 5.54109 1.33331 5.02761 1.33331 4.00065Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M9.33331 4.00065C9.33331 2.97369 9.33331 2.46021 9.56447 2.08301C9.69381 1.87194 9.87127 1.69448 10.0823 1.56514C10.4595 1.33398 10.973 1.33398 12 1.33398C13.0269 1.33398 13.5404 1.33398 13.9176 1.56514C14.1287 1.69448 14.3062 1.87194 14.4355 2.08301C14.6666 2.46021 14.6666 2.97369 14.6666 4.00065C14.6666 5.02761 14.6666 5.54109 14.4355 5.9183C14.3062 6.12936 14.1287 6.30682 13.9176 6.43617C13.5404 6.66732 13.0269 6.66732 12 6.66732C10.973 6.66732 10.4595 6.66732 10.0823 6.43617C9.87127 6.30682 9.69381 6.12936 9.56447 5.9183C9.33331 5.54109 9.33331 5.02761 9.33331 4.00065Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <clipPath id="referrals_dashboard_tab_clip">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

const Referrals = () => {
  const lang = localStorage.getItem("language") || "ar"
  const t = translations[lang]?.referralsPage || translations.en.referralsPage
  const user = useSelector((state) => state.user.user)
  const token = getUserCookies()?.token
  const decoded = token ? jwtDecode(token) : null
  const market_role = decoded?.market_role
  const referralsReadOnly =
    market_role === "2" ||
    market_role === "3" ||
    isProfileModuleReadOnly(user, "referrals")
  const referralsCanDelete =
    !referralsReadOnly && !isProfileModuleDeleteBlocked(user, "referrals")

  const tabList = useMemo(
    () => [
      { id: "dashboard", label: t.tab_dashboard, variant: "dashboard" },
      {
        id: "configuration",
        label: t.tab_configuration,
        iconSrc: "/referrals/filter-horizontal.svg",
      },
      { id: "rewards", label: t.tab_rewards, iconSrc: "/referrals/file-01.svg" },
      {
        id: "users",
        label: t.tab_users,
        iconSrc: "/referrals/user-multiple-admin.svg",
      },
      {
        id: "activity-logs",
        label: t.tab_activity_logs,
        iconSrc: "/referrals/file-admin.svg",
      },
    ],
    [t],
  )

  const [activeTab, setActiveTab] = useState("dashboard")

  const tabComponents = {
    dashboard: (
      <DashboardTab
        onViewAllRewards={() => setActiveTab("rewards")}
        readOnly={referralsReadOnly}
      />
    ),
    configuration: <ConfigurationTab readOnly={referralsReadOnly} />,
    rewards: <RewardsTab readOnly={referralsReadOnly} />,
    users: (
      <UsersTab readOnly={referralsReadOnly} canDelete={referralsCanDelete} />
    ),
    "activity-logs": <ActivityLogsTab readOnly={referralsReadOnly} />,
  }

  return (
    <div className="referrals-page">
      <div className="referrals-header-row">
        <h1 className="referrals-title">{t.page_title}</h1>
      </div>

      <div className="referrals-tabs">
        {tabList.map((tab) => (
          <button
            key={tab.id}
            className={`referrals-tab-btn ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
            type="button"
          >
            <span className="ref-tab-icon">
              {tab.variant === "dashboard" ? (
                <ReferralsDashboardTabIcon />
              ) : (
                <img
                  src={tab.iconSrc}
                  alt=""
                  width={16}
                  height={16}
                  className="ref-tab-icon-img"
                />
              )}
            </span>
            {tab.label}
          </button>
        ))}
      </div>

      {tabComponents[activeTab]}
    </div>
  )
}

export default Referrals
